import mapValues from "lodash/mapValues";
import UnitsConfig from "views/logic/aggregationbuilder/UnitsConfig";
import FieldUnit from "views/logic/aggregationbuilder/FieldUnit";
const fromConfig = (config) => ({
  units: config.units.toFormValues()
});
const toConfig = (formValues, configBuilder) => configBuilder.units(
  new UnitsConfig(mapValues(formValues.units, (unit) => new FieldUnit(unit.unitType, unit.abbrev)))
);
const validate = () => ({});
const UnitsElement = {
  title: null,
  key: "units",
  order: 5,
  allowCreate: () => false,
  component: null,
  fromConfig,
  toConfig,
  validate,
  isEmpty: () => true
};
export default UnitsElement;
